<template>
  <div>
    <!-- Page title -->
    <page-title icon="fas fa-comments-dollar " main="Metas"></page-title>
    <div class="card mt-2 pb-4" style="padding: 0rem 1rem">
        <div  class="col-lg-12 card-header">
          <h5 class="h3 mb-0">Metas</h5>
          <h6 class="text-uppercase text-muted ls-1 mb-1">  Configure quais dados deverão ser listados:  </h6>
        </div>
        <div class="row col-12">
          <div class="col-md-6 mt-3">
            <label class="form-control-label">Período de Vigência</label>
            <multiselect
              v-model="anoParticipation"
              :options="participation"
              :select-label="''"
              :deselect-label="''"
              :selected-label="'Selecionado'"
              label="descricao"
              placeholder="Período de Vigência"
              track-by="id"
            />
          </div>
          <div class="col-md-6 mt-3">
            <label class="form-control-label">Meta</label>
            <multiselect
              v-model="valueGoal"
              :options="optionGoal"
              :select-label="''"
              :deselect-label="''"
              :selected-label="'Selecionado'"
              placeholder="Selecionar Meta"
            ></multiselect>
          </div>
        </div>
        <div class="row col-12">
          <div class="col-md-4 mt-3">
            <label class="form-control-label">Cargo</label>
            <multiselect
              v-model="valueCargo"
              :select-label="''"
              :deselect-label="''"
              :selected-label="'Selecionado'"
              :options="options"
              placeholder="Selecionar Cargo"
            ></multiselect>
          </div>
          <div class="col-md-4 mt-3">
            <label class="form-control-label">Consultor</label>
            <multiselect
              v-model="user"
              :options="users || []"
              placeholder="Selecionar Consultor"
              :select-label="''"
              :deselect-label="''"
              :selected-label="'Selecionado'"
              :disabled="!loadedUsers"
              label="name"
              @search-change="getSalesmens"
            ></multiselect>
          </div>
          <div class="col-md-4 mt-5">
            <base-button
              native-type="submit"
              type="info"
              class="new-event--add"
              v-loading="isLoading"
              @click="getPprReport"
              >
              <i class="fa fa-search"></i>
              Gerar PPR
            </base-button>
            <base-button
              type="secondary"
              class="mr-2"
              @click="clearFilters">
              Limpar Filtros
            </base-button>
          </div>
        </div>
      <!-- PPR Tables -->

      <div id="ppr_tables" class="col-12">
        <div v-for="distribution in data.goals" :key="distribution.distribution" style="margin-bottom: 50px;">
          <h5 class="text-uppercase text-muted ls-1 mb-4">{{ distribution.distribution }}</h5>
          <el-table
            class="table-responsive table-striped mt-4"
            header-row-class-name="thead-light"
            border
            :data="distribution.data"
            min-wid_typeth="500px"
          >
            <el-table-column label="Grupo" prop="grupo" min-width="190" sortable/>
            <el-table-column label="Meta SGV" prop="goal" min-width="180" sortable v-slot="{ row }">
              {{ (row.goal || 0).toLocaleString("pt-BR", { style: "currency", currency: "brl" }) }}
            </el-table-column>
            <el-table-column label="Realizada" prop="salesman_sales" min-width="180" sortable v-slot="{ row }">
              {{ row.salesman_sales.toLocaleString("pt-BR", { style: "currency", currency: "brl" }) }}
            </el-table-column>
            <el-table-column label="Meta Atingida" prop="percentage_goal" min-width="180" sortable v-slot="{ row }">
              {{ row.percentage_goal.toFixed(2) }} %
            </el-table-column>
            <el-table-column label="Percentual Alcançado" prop="percentage_reached" min-width="200" sortable v-slot="{ row }">
              {{ row.percentage_reached.toFixed(2) }} %
            </el-table-column>
            <el-table-column label="Percentual Participação" prop="percentage_participation" min-width="220" sortable v-slot="{ row }">
              {{ row.percentage_participation.toFixed(2) }} %
            </el-table-column>
             <el-table-column label="Recebimento" prop="receivement" min-width="180" sortable v-slot="{ row }">
              {{ row.receivement.toLocaleString("pt-BR", { style: "currency", currency: "brl" }) }}
            </el-table-column>
            <el-table-column label="Valor Resultante" prop="participation_value" min-width="180" sortable v-slot="{ row }">
              {{ row.participation_value.toLocaleString("pt-BR", { style: "currency", currency: "brl" }) }}
            </el-table-column>
          </el-table>
        </div>
        <div style="margin-bottom: 50px;" v-if="data.compliance.data">
          <h5 class="text-uppercase text-muted ls-1 mb-4">{{ data.compliance.distribution }}</h5>
          <el-table
            class="table-responsive table-striped"
            header-row-class-name="thead-light"
            border
            :data="data.compliance.data"
            min-wid_typeth="500px"
          >
            <el-table-column label="Grupo" prop="grupo" min-width="190" sortable/>
            <el-table-column label="Valor Inicial" prop="initial_value" min-width="180" sortable v-slot="{ row }">
              {{ (row.initial_value || 0).toLocaleString("pt-BR", { style: "currency", currency: "brl" }) }}
            </el-table-column>
            <el-table-column label="Valor Pago" prop="paid_value" min-width="180" sortable v-slot="{ row }">
              {{ (row.paid_value || 0).toLocaleString("pt-BR", { style: "currency", currency: "brl" }) }}
            </el-table-column>
            <el-table-column label="% Adimplência" prop="percentage" min-width="180" sortable v-slot="{ row }">
              {{ row.percentage.toFixed(2) }} %
            </el-table-column>
            <el-table-column label="Percentual Alcançado" prop="percentage_reached" min-width="200" sortable v-slot="{ row }">
              {{ row.percentage_reached.toFixed(2) }} %
            </el-table-column>
            <el-table-column label="Percentual Participação" prop="percentage_participation" min-width="220" sortable v-slot="{ row }">
              {{ row.percentage_participation.toFixed(2) }} %
            </el-table-column>
            <el-table-column label="Valor Resultante" prop="participation_value" min-width="180" sortable v-slot="{ row }">
              {{ row.participation_value.toLocaleString("pt-BR", { style: "currency", currency: "brl" }) }}
            </el-table-column>
          </el-table>
        </div>
        <div style="margin-bottom: 50px;" v-if="data.margim.data">
          <h5 class="text-uppercase text-muted ls-1 mb-4">{{ data.margim.distribution }}</h5>
          <el-table
            class="table-responsive table-striped"
            header-row-class-name="thead-light"
            border
            :data="data.margim.data"
            min-wid_typeth="500px"
          >
            <el-table-column label="Grupo" prop="grupo" min-width="190" sortable/>
            <el-table-column label="Custo Total" prop="cost" min-width="180" sortable v-slot="{ row }">
              {{ (row.cost || 0).toLocaleString("pt-BR", { style: "currency", currency: "brl" }) }}
            </el-table-column>
            <el-table-column label="Valor Final" prop="final_value" min-width="180" sortable v-slot="{ row }">
              {{ (row.final_value || 0).toLocaleString("pt-BR", { style: "currency", currency: "brl" }) }}
            </el-table-column>
            <el-table-column label="Margem" prop="margim" min-width="180" sortable v-slot="{ row }">
              {{ row.percentage.toFixed(2) }} %
            </el-table-column>
            <el-table-column label="Percentual Alcançado" prop="percentage_reached" min-width="200" sortable v-slot="{ row }">
              {{ row.percentage_reached.toFixed(2) }} %
            </el-table-column>
            <el-table-column label="Percentual Participação" prop="percentage_participation" min-width="220" sortable v-slot="{ row }">
              {{ row.percentage_participation.toFixed(2) }} %
            </el-table-column>
            <el-table-column label="Valor Resultante" prop="participation_value" min-width="180" sortable v-slot="{ row }">
              {{ row.participation_value.toLocaleString("pt-BR", { style: "currency", currency: "brl" }) }}
            </el-table-column>
          </el-table>
        </div>
      </div>

      <!-- Totals -->

      <div class="tableStyle" v-if="Object.keys(data).length">
        <h5 class="text-uppercase text-muted col-12 mb-4">TOTAL</h5>
        <div style="display: flex; justify-content:space-around;">
          <base-switch v-model="showMetaBayer"  @input="getMetaBayer" label="Plano de Participação Metas Bayer"></base-switch>
          <base-switch v-model="showDirectSale" @input="getDirectSale" label="Venda Direta"></base-switch>
        </div>
        <br><br>
        <el-table
          class="table-responsive table-striped"
          header-row-class-name="thead-light"
          border
          :data="totalValues()"
          min-wid_typeth="500px"
          v-if="reports == true"
        >
          <el-table-column label="" prop="label" min-width="190" sortable/>
          <el-table-column label="Valor" prop="value" min-width="180" sortable v-slot="{ row }">
            {{ row.value.toLocaleString("pt-BR", { style: "currency", currency: "brl" }) }}
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import Modal from "@/components/Modal";
import PageTitle from "@/layouts/PageTitle";
import Multiselect from "@/components/Multiselect/translated_multiselect.vue";


import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
} from "element-ui";

export default {
  name: "app",
  components: {
    PageTitle,
    Modal,
    Multiselect,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
  },
  data() {
    return {
      active: true,
      valueGoal: null,
      valueCargo: null,
      valueSales: null,
      optionGoal:['HF', 'CEREAL'],
      options:['Vendedor', 'Gerente Comercial'],
      participation: [],
      reports: false,
      anoParticipation: "",
      filter: {
        manager: {},
        salesman: {},
        coordinator: {}
      },
      is_salesman: false,
      is_manager: false,
      is_coordinator: false,
      distributions: "",
      loadedUsers: false,
      users: [],
      user: {},
      isLoading: false,
      data: {compliance: {}, margim: {}},
      showMetaBayer: false,
      metaBayer: {},
      showDirectSale: false,
      directSale: 0,
    };
  },
  mounted() {
    this.getParticipation();
    this.getDistributions();
    this.getGroups();
  },
  methods: {
    async getMetaBayer(show = false) {
      if(!show) return

      const response = await this.$http.secured.get("/api/v1/metas_bayer", {
        params: {
          'metas_bayer[participation_ppr_id]': this.anoParticipation.id,
          'metas_bayer[category]': this.valueCargo == "Coordenador" ? 'coordinator' : this.valueCargo == "Gerente Comercial" ? 'manager' : 'salesman'
        }
      })
      this.metaBayer = response.data[0]
    },
    async getDirectSale(show = false) {
      if(!show) return

      // http://localhost:8080/api/v1/direct_sellings?total=true&direct_selling[salesman_id]=1
      const response = await this.$http.secured.get("/api/v1/direct_sellings", {
        params: {
          'total': true,
          'goal[salesman_id]':    this.valueCargo == "Vendedor"    ? this.filter.salesman.id : null,
          'goal[manager_id]':     this.valueCargo == "Gerente Comercial"      ? this.filter.manager.id : null,
          'goal[coordinator_id]': this.valueCargo == "Coordenador" ? this.filter.manager.id : null,
        }
      })

      if(this.valueCargo == "Vendedor")    this.directSale = (response.data || 0) * 0.45 * 0.60
      if(this.valueCargo == "Gerente Comercial")      this.directSale = (response.data || 0) * 0.45 * 0.20
      if(this.valueCargo == "Coordenador") this.directSale = (response.data || 0) * 0.45 * 0.20
    },
    totalValues() {
      const data = []
      if(this.data && Object.keys(this.data).length) data.push({label: 'PPR', value: this.pprValue})
      if(this.showMetaBayer && this.metaBayer.participation_value) data.push({label: 'Participação Metas Bayer ', value: this.metaBayer ? this.metaBayer.participation_value || 0 : 0})
      if(this.showDirectSale && this.directSale) data.push({label: 'Venda Direta ', value: this.directSale || 0})
      data.push({label: 'Valor Resultante', value: data.reduce((sum, current) => sum + current.value, 0)})

      return data
    },
    getDistributions() {
      this.$http.secured
        .get("/api/v1/distributions")
        .then((response) => this.distributions = response.data);
    },
    async getPprReport() {
      if(!this.anoParticipation) {
        return this.$toasted.global.defaultError({ msg: "Necessário selecionar Período de Vigência",});
      }

      if(!this.valueGoal) {
        return this.$toasted.global.defaultError({ msg: "Necessário selecionar a Meta",});
      }

      if(!this.valueCargo) {
        return this.$toasted.global.defaultError({ msg: "Necessário selecionar o Cargo",});
      }

      if(!this.user) {
         return this.$toasted.global.defaultError({ msg: "Necessário selecionar o Consultor",});
      }

      this.isLoading = true

      const data = {
        'goal[salesman_id]': this.valueCargo == "Vendedor" ? this.user.id : null,
        'goal[manager_id]': ["Gerente Comercial", "Coordenador"].includes(this.valueCargo) ? this.user.id : null,
        'comercial_pprs[category]': this.valueCargo == "Coordenador" ? 'coordinator' : this.valueCargo == "Gerente Comercial" ? 'manager' : 'salesman',
        'comercial_pprs[tipo]': this.valueGoal,
        'participation_ppr[id]': this.anoParticipation.id,
      }

      try {
        const response = await this.$http.secured.get('/api/v1/report/ppr_goals', {params: data})
        this.data = response.data
        console.log("DDARA: ", this.data)
      } catch (error) {
        console.error(error)
      }

      this.reports = true;
      this.isLoading = false
    },
    checkTypeUser() {
      if(this.valueCargo == "Vendedor")
          this.getSalesmens('')
      if(this.valueCargo == "Gerente Comercial")
          this.getManagers('')
      if(this.valueCargo == "Coordenador")
          this.getCoordinator('')
    },
    getGroups() {
      this.$http.secured.get("/api/v1/grupos").then((response) => {
        this.groups = response.data
      });
    },
    getSalesmens(query) {
      var data = {
        q: { name: query, is_salesman: true, status: this.active },
      };
      if (this.anoParticipation && this.anoParticipation.id)
        data.q["anosafra_id"] = this.anoParticipation.anosafra_id;
      this.$http.secured.get("/api/v1/users", { params: data }).then((response) => {
        this.users = response.data.users || []
        this.loadedUsers = true
      })
    },
    getManagers(query) {
        var data = {
            q: { name: query, is_manager: true, status: this.active },
        };
        if (this.anoParticipation && this.anoParticipation.id)
          data.q["anosafra_id"] = this.anoParticipation.anosafra_id;
        this.$http.secured.get("/api/v1/users", { params: data }).then((response) => {
          this.users = response.data.users
          this.loadedUsers = true
        })
    },
    getCoordinator(query) {
      var data = {
          q: { name: query, is_coordinator: true, status: this.active },
      };
      if (this.anoParticipation && this.anoParticipation.id)
        data.q["anosafra_id"] = this.anoParticipation.anosafra_id;
      this.$http.secured
      .get("/api/v1/users", { params: data })
      .then((response) => {
          this.users = response.data.users
          this.loadedUsers = true
      })
    },
    getParticipation(){
      this.$http.secured
        .get(`/api/v1/admin/participation_pprs`, { params: { name_only: true, unpaged: true } })
        .then((response) => {
          this.participation = response.data;
        })
        .catch((error) => this.setError(error, "Something went wrong"));
    },  
    clearFilters() {
      this.anoParticipation = ""
      this.valueGoal = "",
      this.valueCargo = "",
      this.user = ""
    },
  },
  computed: {
    pprValue() {
      if (!this.data.goals) return 0
      return this.data.goals.reduce((sum, distribution) => sum + distribution.data.reduce((sum, participation) => sum + participation.participation_value, 0), 0)
    },
  },
  watch:{
    'valueCargo': function() {
      this.checkTypeUser();
    },
  }
};
</script>

<style>
.tableStyle {
  margin-top: 3%;
}
.tableStyle h6 {
  font-size: 12px;
}
.title {
  margin-bottom: 2%;
}
.el-table__row {
  background-color: white;
  text-align: center;
}
.checkboxtext {
  font-size: 100px;
  display: inline;
  zoom: 1.5;
  margin-top: 2;
}
.labelCheck {
  margin-left: 5px;
}
</style>
